import { MemberType } from './member-type';
import { WebsocketParams } from './websocket-params';

export class StreamerWebsocketParams implements Pick<WebsocketParams, 'memberType' | 'memberDisplayName' | 'joinCode' | 'securityPin' | 'token'> {
  memberType: Required<WebsocketParams>['memberType'];
  memberDisplayName: Required<WebsocketParams>['memberDisplayName'];
  joinCode: Required<WebsocketParams>['joinCode'];
  securityPin: Required<WebsocketParams>['securityPin'];
  token: Required<WebsocketParams>['token'];

  constructor(
    memberDisplayName: StreamerWebsocketParams['memberDisplayName'],
    joinCode: StreamerWebsocketParams['joinCode'],
    securityPin?: StreamerWebsocketParams['securityPin'],
    token?: StreamerWebsocketParams['token']
  ) {
    this.memberType = MemberType.STREAMER;
    this.memberDisplayName = memberDisplayName;
    this.joinCode = joinCode;
    this.securityPin = securityPin;
    this.token = token;
  }

  asQueryParams() {
    const params = new URLSearchParams();
    params.append('memberType', this.memberType);
    params.append('memberDisplayName', this.memberDisplayName);
    params.append('joinCode', this.joinCode);
    if (this.securityPin) params.append('securityPin', this.securityPin);
    if (this.token)  params.append('token',  `Bearer ${this.token}`);
    return params.toString();
  }

  isModerator() {
    return false;
  }
}
